module.exports = __webpack_public_path__ + "static/img/schlauch.dd0e75d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schlauch.gif
// module id = 302
// module chunks = 0